var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurvey01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 240,
    viewBox: "0 0 111 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph90q7tn9b",
    x1: "253.086%",
    x2: "225.708%",
    y1: "622.612%",
    y2: "546.235%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#213F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#23AF4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9ogquztfre",
    x1: "12.46%",
    x2: "57.055%",
    y1: "170.068%",
    y2: "24.402%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#213F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#23AF4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wzabz8nqzh",
    x1: "-40.454%",
    x2: "76.331%",
    y1: "147.77%",
    y2: "-7.159%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#213F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#23AF4D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pal7syg5ka",
    d: "M66.81 2.316L0 75.511v.563L67.09 2.572c.923-1.01 2.15-1.545 3.431-1.545.576 0 1.163.108 1.738.33 1.852.716 3.001 2.391 3.001 4.372v90.564c0 21.114-7.846 41.337-22.092 56.945L0 211.488v.562l53.448-58.557c14.311-15.677 22.192-35.992 22.192-57.2V5.73c0-2.141-1.243-3.952-3.244-4.725-.62-.24-1.255-.358-1.878-.358-1.384 0-2.712.579-3.708 1.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "omruj7fi0d",
    d: "M41.95.86L0 46.54V119.6l34.576-37.643c7.704-8.388 11.972-19.322 11.972-30.664V2.628c0-1.59-1.31-2.628-2.667-2.628-.686 0-1.385.265-1.932.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i6iwiep9mg",
    d: "M70.784 0C59.91 0 49.544 4.607 42.217 12.692L0 59.302v53.834h.13c6.782-.036 13.254-2.923 17.828-7.972l91.256-100.75c.47-.516.684-1.128.69-1.73V2.63C109.89 1.279 108.836 0 107.277 0H70.784z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1164.000000, -358.000000) translate(144.000000, 126.000000) translate(1020.000000, 232.000000) translate(72.558140, 106.024962) scale(-1, 1) translate(-72.558140, -106.024962) translate(34.415013, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kw9kx8fcdc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pal7syg5ka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ph90q7tn9b)",
    d: "M66.81 2.316L0 75.511v.563L67.09 2.572c.923-1.01 2.15-1.545 3.431-1.545.576 0 1.163.108 1.738.33 1.852.716 3.001 2.391 3.001 4.372v90.564c0 21.114-7.846 41.337-22.092 56.945L0 211.488v.562l53.448-58.557c14.311-15.677 22.192-35.992 22.192-57.2V5.73c0-2.141-1.243-3.952-3.244-4.725-.62-.24-1.255-.358-1.878-.358-1.384 0-2.712.579-3.708 1.67",
    mask: "url(#kw9kx8fcdc)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1164.000000, -358.000000) translate(144.000000, 126.000000) translate(1020.000000, 232.000000) translate(87.201266, 116.891443) scale(-1, 1) translate(-87.201266, -116.891443) translate(63.701266, 56.891443)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3vt7jy2sif",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#omruj7fi0d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9ogquztfre)",
    d: "M41.95.86L0 46.54V119.6l34.576-37.643c7.704-8.388 11.972-19.322 11.972-30.664V2.628c0-1.59-1.31-2.628-2.667-2.628-.686 0-1.385.265-1.932.86",
    mask: "url(#3vt7jy2sif)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1164.000000, -358.000000) translate(144.000000, 126.000000) translate(1020.000000, 232.000000) translate(55.684655, 182.677561) scale(-1, 1) translate(-55.684655, -182.677561) translate(0.668043, 126.066266)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o3fjwf0rli",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i6iwiep9mg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wzabz8nqzh)",
    d: "M70.784 0C59.91 0 49.544 4.607 42.217 12.692L0 59.302v53.834h.13c6.782-.036 13.254-2.923 17.828-7.972l91.256-100.75c.47-.516.684-1.128.69-1.73V2.63C109.89 1.279 108.836 0 107.277 0H70.784z",
    mask: "url(#o3fjwf0rli)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurvey01);
export default __webpack_public_path__ + "static/media/bg_survey_01.6ef78b703065bcda732becd048577acd.svg";
export { ForwardRef as ReactComponent };